import { Link } from "react-router-dom";
import { COMPANY, NAV_LINKS } from "@/lib/siteData";
import { Mail, Phone, MapPin, Instagram, Linkedin } from "lucide-react";
import Logo from "@/components/Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="mb-6">
            <Logo variant="light" className="h-9 md:h-10" />
          </div>
          <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md">
            Modular kitchens, wardrobes, residential storage and office furniture — manufactured in India. A brand of {COMPANY.legal} · Established {COMPANY.established}.
          </p>
        </div>

        <div>
          <div className="overline text-gold mb-4">Explore</div>
          <ul className="space-y-2.5">
            {NAV_LINKS.slice(0, 6).map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.to.replace(/\//g, "") || "home"}`}
                  className="text-white/80 hover:text-gold text-sm transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="overline text-gold mb-4">Reach us</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0 text-gold" /><span>{COMPANY.address}</span></li>
            <li className="flex gap-2.5"><Phone size={16} className="shrink-0 text-gold" /><a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-gold">{COMPANY.phone}</a></li>
            <li className="flex gap-2.5"><Mail size={16} className="shrink-0 text-gold" /><a href={`mailto:${COMPANY.email}`} className="hover:text-gold">{COMPANY.email}</a></li>
          </ul>
          <div className="mt-5 flex items-center gap-3">
            <a
              href="https://www.instagram.com/tarushfurniture/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Tarush on Instagram"
              data-testid="footer-social-instagram"
              className="w-9 h-9 inline-flex items-center justify-center border border-white/20 text-white/80 hover:text-navy hover:bg-gold hover:border-gold transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href="https://www.linkedin.com/company/tarush/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Tarush on LinkedIn"
              data-testid="footer-social-linkedin"
              className="w-9 h-9 inline-flex items-center justify-center border border-white/20 text-white/80 hover:text-navy hover:bg-gold hover:border-gold transition-colors"
            >
              <Linkedin size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</span>
          <span>Made with intention in India.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
